// Vuetify 2 initialization
import Vue from 'vue'
import Vuetify from "vuetify"
import it from 'vuetify/lib/locale/it'
const currentLocale = document.documentElement.lang ?? 'it';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { it },
        current: currentLocale,
    },
    icons: {
        iconfont: 'md', //Material design icons
    },
    theme: {
        options: {
            customProperties: true,
        },
        dark: true,
        themes: {
            dark: {
                primary: '#7AA938', //green
                primary_dark: '#45601F',
                secondary: '#1E4EA0', //blue
                tertiary: '#546E7A', //blue-grey
                fourth: '#5E35B1', //purple
                fifth: '#F4511E', //deep orange
                attention: '#FF9800', //orange
                error: '#C92323', //red
                excel: '#1B5E20' //dark green
            }
        }
    },
});
